import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of, throwError } from 'rxjs';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { BaseActionTypes } from '../../actions/base.actions';
import { getToken } from '../../selectors/base.selectors';
import { State } from '../../index';
import { FachbereichActionTypes, GetFachbereicheResponse } from '../../actions/mdqx/fachbereich.actions';
import { HttpService } from '../../../services/http.service';
import { FachbereichEntity } from '../../../entities/mdqx/fachbereich.entity';
import { DaveActions } from '../../actions/actions';

enum ErrorCodes {
    Get = 'Fachbereiche Abrufen fehlgeschlagen',
}

@Injectable()
export class FachbereichEffects {
    
    get$ = createEffect(() => this.actions$.pipe(
        ofType(FachbereichActionTypes.GetRequest),
        map(
            () => `
            {
                fachbereich {
                    ${FachbereichEntity.GqlFields}
                }
            }`,
        ),
        withLatestFrom(this.store.select(getToken)),
        switchMap(([query, token]) =>
            this.api.graphQl({ query }, { token }).pipe(
                map(res => res && res.fachbereich),
                concatMap(res =>
                    res
                        ? [
                              new GetFachbereicheResponse(
                                  res.map(fachbereich => new FachbereichEntity(fachbereich)),
                              ),
                          ]
                        : throwError('empty response'),
                ),
                catchError((err, caught) => of(BaseActionTypes.ErrorAction({
                    Payload: {
                        ToasterMessage: ErrorCodes.Get,
                        Err: err,
                        Caught: caught,
                    }
                }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions<DaveActions>,
        private api: HttpService,
        private store: Store<State>,
    ) {}
}
